<!--Desktop Back Button (Kids)-->
@if (isKid) {
<div class="bg-primary pt-3 d-none d-lg-block">
  <div class="container">
    <div class="d-none d-lg-flex text-white page-back-button-section align-items-center" (click)="goBack()">
      <span class="material-icons me-2">arrow_back_ios_new</span>
    </div>
  </div>
</div>
}

<!--Desktop Banner-->
<fgb-desktop-nav-banner [pageName]="'games.page.arcade.title' | translate" [imageName]="'arcade'"></fgb-desktop-nav-banner>

<!--Desktop Back Button-->
@if (!isKid) {
<div class="container pt-3 d-none d-lg-block">
  <button class="back-btn d-flex align-items-center justify-content-center" (click)="goBack()" aria-label="Back">
    <span class="material-icons text-white">arrow_back_ios</span>
  </button>
</div>
}

<!--Mobile Navigation-->
<div class="bg-primary d-lg-none mobile-header-background"></div>
<fgb-mobile-nav-menu [pageName]="'games.page.arcade.title' | translate"></fgb-mobile-nav-menu>

<div class="container pt-3 mobile-page-content">
  <div class="arcade-grid d-lg-flex mb-4 animate-in delay-1">
    <div class="arcade-tile" (click)="launchGame(matchEmAllURL)">
      <img [src]="'games/arcade/match-em-all.jpg' | contentAssetImage" />
    </div>

    <div class="arcade-tile" (click)="launchGame(shuffleConeURL)">
      <img [src]="'games/arcade/shuffle-cone.jpg' | contentAssetImage" />
    </div>
  </div>
  <div class="arcade-grid d-lg-flex mb-4 animate-in delay-2">
    <div class="arcade-tile" (click)="launchGame(flappyGullyURL)">
      <img [src]="'games/arcade/flappy-gully.jpg' | contentAssetImage" />
    </div>

    <div class="arcade-tile" (click)="launchGame(mitomaMagicURL)">
      <img [src]="'games/arcade/mitoma-magic.jpg' | contentAssetImage" />
    </div>
  </div>

  <div class="arcade-grid d-lg-flex animate-in delay-3">
    <div class="arcade-tile" (click)="launchGame(snakeURL)">
      <img [src]="'games/arcade/snake.jpg' | contentAssetImage" />
    </div>
  </div>
</div>
